import React, { useState } from "react";

export default function StatsOverviewPageFr() {
  const [lightbox, setLightbox] = useState({ open: false, src: "", alt: "" });

  const Thumbnail = ({ src, alt }) => (
    <div style={{ marginTop: 8 }}>
      <img
        src={src}
        alt={alt}
        onClick={() => setLightbox({ open: true, src, alt })}
        style={{
          width: "15cm",
          height: "auto",
          display: "block",
          cursor: "zoom-in",
          borderRadius: 8,
        }}
      />
    </div>
  );

  return (
    <>
      <div
        style={{
          maxWidth: 900,
          margin: "48px auto",
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 2px 12px #0001",
          padding: 36,
          fontFamily: "inherit",
          color: "#222",
        }}
      >
        <h2 id="stats-hero" style={{ fontSize: 42, fontWeight: 900, color: "#006b44", margin: 0 }}>
          Services analytiques pour radios en ligne
        </h2>

        <p style={{ margin: "16px 0 10px", fontSize: 18 }}>
          <strong>Radiomonitor.net</strong> n'est pas qu'une collecte de données, mais une analyse approfondie. Vous voyez comment
          l'audience évolue en temps réel, suivez la dynamique par jour, semaine, mois ou même année, et analysez les prime times et l'efficacité du contenu.
        </p>
        <p style={{ margin: "0 0 24px", fontSize: 18 }}>
          Voici en détail les services qui rendent cela possible:
        </p>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Auditeurs actifs</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Que se passe-t-il maintenant?</b><br />
            Affiche le nombre d'auditeurs en temps réel, les appareils et les villes. Une analyse live «ici et maintenant».
          </p>
          <Thumbnail
            src="/assets/stats/LiveService(uk).png"
            alt="Auditeurs actifs — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Auditeurs</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Qui vous écoute?</b><br />
            Compte toutes les connexions et les auditeurs uniques. La métrique de base sans laquelle aucune autre analyse n'a de sens.
          </p>
          <Thumbnail
            src="/assets/stats/ListenersService(uk).png"
            alt="Auditeurs — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            Appareils & OS (Devices & OS)
            <span style={{ display: 'block', fontSize: 16, fontWeight: 600, color: '#4a4a4a' }}>
              Devices & OS / Audience Devices & Operating Systems
            </span>
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Ce service montre depuis quels appareils et systèmes d’exploitation on écoute votre station à la date choisie (basé sur les sessions).
            Le système agrège les sessions d’écoute et construit un profil technique clair de l’audience, afin de savoir où «habite» votre auditeur et comment optimiser player, site, application et créations.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Le rapport présente:</b>
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Type d’appareil (ex.: Mobile / Desktop / Other)</li>
            <li>Système d’exploitation (Android, iOS, Windows, macOS, etc.)</li>
            <li>Famille d’appareils (device family, top catégories)</li>
            <li>Clients (top client — types d’apps/player côté auditeur)</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Pourquoi c’est utile:</b>
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Optimisation produit: savoir ce qui domine (Android vs iOS, mobile vs desktop) pour prioriser UI/UX, tests et support.</li>
            <li>Qualité du stream/player: détecter rapidement les anomalies sur certains OS/clients (si un player provoque beaucoup de coupures ou de sessions «bizarres»).</li>
            <li>Planification de développement: décider avec des données s’il faut une app dédiée/mise à jour et quelles plateformes supporter en premier.</li>
            <li>Publicité & partenariats: adapter formats et créations au profil technique réel et le démontrer aux annonceurs.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Période d’analyse:</b> date sélectionnée (filtre par pays possible).
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Méthodologie:</b> agrégation des sessions d’écoute sur la date choisie → regroupement par type d’appareil / OS / famille / client → comptage du volume et de la part (%) dans le total.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 8 }}>
            <Thumbnail src="/assets/stats/Devices&OS01_fr.png" alt="Devices & OS — répartition" />
            <Thumbnail src="/assets/stats/Devices&OS02_fr.png" alt="Devices & OS — détails par client" />
          </div>
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Géographie des auditeurs</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Où vous écoute-t-on?</b><br />
            Détermine la répartition de l'audience par pays et villes, ainsi que la part d'auditeurs ukrainiens. Donne une vision claire de la couverture par région.
          </p>
          <Thumbnail
            src="/assets/stats/Geo(uk).png"
            alt="Géographie des auditeurs — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Pics de charge</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Quand êtes-vous le plus écouté?</b><br />
            Identifie les heures de pointe et les prime times. Idéal pour planifier les blocs publicitaires.
          </p>
          <Thumbnail
            src="/assets/stats/PeakService(uk).png"
            alt="Pics de charge — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            Profil horaire moyen par jour de semaine (AHA)
            <span style={{ display: 'block', fontSize: 16, fontWeight: 600, color: '#4a4a4a' }}>
              Day-of-Week Listening Profile / Average Hourly Audience by Day of Week
            </span>
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Ce module montre comment l'audience se comporte selon les jours de semaine, heure par heure. Utile pour calibrer la grille et les contenus spéciaux.
          </p>
          <Thumbnail
            src="/assets/stats/AhaService(uk).png"
            alt="AHA — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>TSL</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Combien de temps écoute-t-on?</b><br />
            Calcule le temps d'écoute moyen (TSL) et révèle le niveau d'engagement.
          </p>
          <Thumbnail
            src="/assets/stats/TslService(uk).png"
            alt="TSL — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>TLH</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            TLH (Total Listening Hours) indique combien d'heures au total votre station a été écoutée sur la période choisie.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Que calcule le TLH ?</b><br />
            Il additionne la durée de toutes les sessions d'écoute et la convertit en heures :
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>TLH par jour — combien d'heures-personnes ont été écoutées un jour donné.</li>
            <li>TLH sur une période (total) — le volume d'heures d'écoute cumulé sur l'intervalle (jour/semaine/mois).</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            En clair, TLH répond à la question : « Combien de temps l'audience a-t-elle passé avec notre station ? ».
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>A quoi ça sert ?</b><br />
            TLH est une des « monnaies » les plus parlantes pour valoriser l'audience et la monétisation :
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Vente pub : TLH se présente facilement à un annonceur comme volume de contact avec le contenu — « autant d'heures-personnes d'écoute ».</li>
            <li>Comparer les périodes : voir si le volume total d'écoute progresse semaine après semaine ou mois après mois.</li>
            <li>Mesurer l'effet des changements/promo : après une campagne, un nouveau format ou de nouveaux animateurs, TLH montre si le « temps d'attention » a augmenté.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Comment lire le rapport TLH ?</b>
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Graphique quotidien — nombre d'heures cumulées pour chaque jour.</li>
            <li>TLH (total) — la somme d'heures sur toute la période.</li>
            <li>Nombre de sessions — nombre de connexions (aide à comprendre ce qui fait varier le TLH).</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            TLH complète parfaitement des métriques comme le TSL, mais à lui seul il donne un chiffre très « business » : combien d'heures d'attention la station a reçu.
          </p>
          <Thumbnail src="/assets/stats/tlh_fr.png" alt="TLH — exemple d'interface" />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Nouveaux auditeurs</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Combien de nouveaux sont arrivés?</b><br />
            Mesure le nombre de nouveaux auditeurs par jour, semaine ou mois pour évaluer la croissance.
          </p>
          <Thumbnail
            src="/assets/stats/NewListenersService(uk).png"
            alt="Nouveaux auditeurs — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>ADR (Average Daily Reach)</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Couverture quotidienne moyenne de la station.</b>
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Cet indicateur montre combien d’<b>auditeurs uniques</b> en moyenne viennent chaque jour sur votre station pendant la période choisie.
            Pour chaque journée, le système compte les personnes distinctes qui ont écouté la radio puis moyenne ces valeurs sur l’ensemble de la période.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>ADR permet de:</p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>évaluer la <b>véritable taille quotidienne</b> de l’audience;</li>
            <li>voir à quel point la station attire des auditeurs de manière régulière pendant la période analysée;</li>
            <li>soutenir les offres commerciales avec un <b>chiffre clair d’audience</b> pour le période.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Période d’analyse:</b> plage de dates choisie dans l’historique disponible.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}><b>Méthode de calcul:</b></p>
          <ol style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Pour chaque jour du périmètre, compter le <b>nombre d’auditeurs uniques sur 24 h</b>.</li>
            <li>Moyenner les valeurs journalières pour obtenir l’Average Daily Reach de la période.</li>
          </ol>
          <Thumbnail
            src="/assets/stats/ADR (fr).png"
            alt="ADR — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>AQH (Average Quarter-Hour Audience)</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Nombre moyen d’auditeurs simultanés.</b>
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Indique <b>combien d’auditeurs en moyenne écoutent votre station en même temps</b> sur la période choisie.
            Les sessions sont agrégées par intervalles horaires et on obtient la taille moyenne de l’audience pour chaque slot.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>AQH permet de:</p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>voir comment évolue l’audience au fil de la journée;</li>
            <li>identifier les heures les plus fortes et les plus faibles;</li>
            <li>placer les blocs publicitaires dans les slots les plus rentables;</li>
            <li>évaluer l’impact des changements de grille sur l’audience réelle.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Période d’analyse:</b> plage de dates choisie dans l’historique disponible.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}><b>Méthode de calcul:</b></p>
          <ol style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Compter pour chaque minute le nombre de sessions actives.</li>
            <li>Pour chaque intervalle (ex. heure), calculer la <b>moyenne des minutes</b>.</li>
            <li>Assembler ces valeurs pour construire le profil AQH du période.</li>
          </ol>
          <Thumbnail
            src="/assets/stats/AQH (fr)01.png"
            alt="AQH — graphique"
          />
          <Thumbnail
            src="/assets/stats/AQH (fr)02.png"
            alt="AQH — heatmap"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            Reach (Period Reach)
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Reach indique <b>combien d’auditeurs uniques</b> ont écouté au moins une fois la station pendant la période choisie.
            Toutes les visites répétées d’un même auditeur unique — sur une même journée, semaine ou mois — sont comptées une seule fois.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>Reach permet de:</p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>voir combien d’auditeurs uniques ont allumé la station au moins une fois par jour, semaine, mois ou intervalle libre;</li>
            <li>montrer aux annonceurs combien de personnes différentes ont réellement pu entendre leur publicité sur cette période;</li>
            <li>consulter la géographie de ces auditeurs uniques (top pays + part «sans géographie»).</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>Comment c’est calculé:</p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Sur la période choisie, nous rassemblons toutes les personnes qui ont écouté au moins une fois et comptons chaque auditeur une seule fois.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Si un auditeur écoute 10 fois pendant la semaine, Reach le considère quand même comme 1 auditeur hebdomadaire, pas 10.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Exemple&nbsp;: une personne écoute lundi, mercredi et vendredi — dans le Reach hebdomadaire elle compte comme un seul auditeur pour la semaine.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Reach reflète donc non pas le nombre d’allumages, mais le nombre de personnes différentes qui ont écouté votre radio au moins une fois sur la période.
          </p>
          <Thumbnail
            src="/assets/stats/Reach_fr.png"
            alt="Reach — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Rétention</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Reviennent-ils?</b><br />
            Mesure combien de nouveaux auditeurs reviennent le lendemain ou la semaine suivante. Capital pour évaluer la première impression.
          </p>
          <Thumbnail
            src="/assets/stats/RetentionService(uk).png"
            alt="Rétention — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Indice de loyauté</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Quel est votre noyau dur?</b><br />
            Identifie les auditeurs réguliers et montre la force du brand.
          </p>
          <Thumbnail
            src="/assets/stats/LoyaltyService(uk).png"
            alt="Indice de loyauté — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>TOP</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Qu'est-ce qui est le plus populaire?</b><br />
            Produit des classements: villes, plateformes, appareils, et, si disponible, musique et shows. Statistiques prêtes pour les présentations.
            <br />
            Nécessite l'import de la grille d'antenne.
          </p>
          <Thumbnail
            src="/assets/stats/Top40Service(uk).png"
            alt="TOP — exemple d'interface"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>LTR (Listen-Through Rate)</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Taux d'écoute complet des spots audio.</b><br />
            LTR montre quelle part des auditeurs reste jusqu'à la fin de chaque bloc publicitaire. On passe de «le spot est passé» à une
            question plus honnête : <b>«Combien de personnes ont réellement entendu la pub jusqu'au bout?»</b>
          </p>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Ce que mesure LTR</h4>
          <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li><b>Impressions</b> — combien d'auditeurs uniques sont connectés au début du bloc;</li>
            <li><b>Completions</b> — combien restent jusqu'à la fin;</li>
            <li><b>LTR, %</b> — la part de ceux qui vont au bout (Completions/Impressions × 100).</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Les données s'affichent pour chaque bloc de la journée choisie : heures de début et de fin, composition (spots), taille du public
            et pourcentage d'écoute complète.
          </p>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Comment ça marche</h4>
          <ol style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>Le service importe la grille réelle et détecte automatiquement les blocs publicitaires.</li>
            <li>Pour chaque bloc, il enregistre qui écoute au démarrage (impressions) et qui reste jusqu'au bout (completions) via les sessions.</li>
            <li>Sur cette base, le système calcule le LTR en pourcentage pour chaque bloc.</li>
          </ol>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Pourquoi l'utiliser</h4>
          <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>Évaluer l'efficacité des pubs audio et repérer les chutes d'audience.</li>
            <li>Comparer les créations et emplacements selon la capacité à retenir les auditeurs.</li>
            <li>Optimiser la grille et identifier les meilleurs créneaux horaires.</li>
            <li>Renforcer l'argumentaire commercial avec un pourcentage réel d'écoute complète.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Le service LTR est disponible dans la section «Statistiques» comme outil dédié pour l'analyse des blocs publicitaires.
          </p>
          <Thumbnail src="/assets/stats/lpt_fr.png" alt="LTR — exemple d'interface" />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            Quartiles LTR (Listen-Through Rate by Quartiles)
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Écoute des spots audio par quartiles.</b>
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Le service Quartiles LTR montre combien d’auditeurs réels ont écouté un spot publicitaire jusqu’à 25%, 50%, 75% et 100% de sa durée.
            Pour chaque diffusion, le système enregistre les Impressions (auditeurs uniques présents au départ) et combien atteignent chaque quartile.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Là où le LTR classique donne un seul point final («écouté/pas écouté»), Quartiles LTR indique l’endroit exact où l’audience commence à décrocher.
          </p>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Ce que mesure Quartiles LTR</h4>
          <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>
              <b>Impressions</b> — combien d’auditeurs uniques sont connectés au démarrage du spot.
            </li>
            <li>
              <b>Q25/Q50/Q75/Q100</b> — combien atteignent 25%, 50%, 75% et 100% de la durée.
            </li>
            <li>
              Pour chaque diffusion, une ligne quotidienne avec heures de début/fin, nom du spot et audience à chaque quartile.
            </li>
          </ul>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Analyses supplémentaires</h4>
          <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>
              <b>GEO par spot</b> — combien d’auditeurs de cette diffusion viennent de chaque pays.
            </li>
            <li>
              <b>Niveau IP</b> — liste technique des adresses IP pour un spot et un pays précis.
            </li>
          </ul>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Comment ça marche</h4>
          <ol style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>Le service lit le planning réel et détecte toutes les diffusions publicitaires de la journée.</li>
            <li>Pour chaque diffusion, il identifie les auditeurs présents au départ (impressions).</li>
            <li>Les données de session indiquent quelle fraction du spot a été réellement écoutée (tolérance ±5 s comme pour le LTR classique).</li>
            <li>Chaque auditeur est classé dans le quartile maximal atteint (0/25/50/75/100%), puis le système compte l’audience par niveau.</li>
            <li>Parallèlement, un découpage GEO (pays → auditeurs) et une liste IP sont générés.</li>
          </ol>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Pourquoi l'utiliser</h4>
          <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>Mesurer réellement l’efficacité d’un spot audio — pas seulement «il est passé à l’antenne».</li>
            <li>Comparer les créatifs et placements selon la profondeur d’écoute.</li>
            <li>Évaluer la position dans le bloc (premier, milieu, dernier) et voir où l’audience tient le mieux.</li>
            <li>Analyser le GEO — comment réagissent les pays et si la campagne touche les marchés visés.</li>
            <li>Effectuer des audits techniques poussés grâce au niveau IP si nécessaire.</li>
            <li>
              Activer un modèle «paiement par spot réellement écouté» — compter uniquement ceux qui atteignent 50–75% dans le pays ciblé.
            </li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Quartiles LTR est disponible dans la section «Statistiques» comme outil dédié avec détail par quartiles, GEO et IP pour chaque spot.
          </p>
          <Thumbnail src="/assets/stats/quartiles_ltr_fr01.png" alt="Quartiles LTR — tableau des quartiles" />
          <Thumbnail src="/assets/stats/quartiles_ltr_fr02.png" alt="Quartiles LTR — vue GEO" />
          <Thumbnail src="/assets/stats/quartiles_ltr_fr03.png" alt="Quartiles LTR — détail IP" />
        </section>

        <section>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Statistiques publicitaires</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Quelle est l'efficacité des pubs?</b><br />
            Calcule impressions, reach, fréquence et CPM. Offre une statistique claire pour vos clients.
            <br />
            Nécessite l'import de la grille d'antenne.
          </p>
          <Thumbnail
            src="/assets/stats/AdsService(uk).png"
            alt="Statistiques pub — exemple d'interface"
          />
        </section>
      </div>

      {lightbox.open && (
        <div
          onClick={() => setLightbox({ open: false, src: "", alt: "" })}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999,
            cursor: "zoom-out",
          }}
        >
          <img
            src={lightbox.src}
            alt={lightbox.alt}
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              borderRadius: 12,
              boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
            }}
          />
        </div>
      )}
    </>
  );
}
